var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333V15.8333",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 18.3333H7.08325L7.36659 16.92C7.40433 16.7312 7.50631 16.5612 7.6552 16.4391C7.80408 16.3169 7.99067 16.2501 8.18325 16.25H11.8166C12.0092 16.2501 12.1958 16.3169 12.3446 16.4391C12.4935 16.5612 12.5955 16.7312 12.6333 16.92L12.9166 18.3333Z",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 4.16663L16.6241 4.42996C17.4491 4.70496 17.8616 4.84246 18.0975 5.16996C18.3333 5.49746 18.3333 5.93246 18.3333 6.80163V6.86246C18.3333 7.57913 18.3333 7.93829 18.1608 8.23163C17.9883 8.52496 17.6741 8.69913 17.0475 9.04829L14.5833 10.4166M4.16663 4.16663L3.37579 4.42996C2.55079 4.70496 2.13829 4.84246 1.90246 5.16996C1.66663 5.49746 1.66663 5.93329 1.66663 6.80163V6.86246C1.66663 7.57913 1.66663 7.93829 1.83913 8.23163C2.01163 8.52496 2.32579 8.69913 2.95246 9.04829L5.41663 10.4166M9.28829 5.01913C9.60496 4.44996 9.76329 4.16663 9.99996 4.16663C10.2366 4.16663 10.395 4.44996 10.7116 5.01913L10.7933 5.16579C10.8833 5.32746 10.9283 5.40746 10.9983 5.46079C11.0691 5.51413 11.1566 5.53413 11.3316 5.57329L11.49 5.60996C12.105 5.74913 12.4125 5.81829 12.4858 6.05329C12.5591 6.28913 12.3491 6.53413 11.93 7.02413L11.8216 7.15079C11.7025 7.28996 11.6425 7.35913 11.6158 7.44579C11.5891 7.53246 11.5983 7.62496 11.6158 7.81079L11.6325 7.97996C11.6958 8.63413 11.7275 8.96163 11.5366 9.10663C11.345 9.25163 11.0566 9.11913 10.4808 8.85413L10.3325 8.78579C10.1683 8.71079 10.0866 8.67329 9.99996 8.67329C9.91329 8.67329 9.83163 8.71079 9.66746 8.78579L9.51913 8.85413C8.94329 9.11996 8.65496 9.25163 8.46329 9.10663C8.27163 8.96163 8.30413 8.63413 8.36746 7.97996L8.38413 7.81079C8.40163 7.62496 8.41079 7.53246 8.38413 7.44579C8.35746 7.35996 8.29746 7.28996 8.17829 7.15079L8.06996 7.02413C7.65079 6.53413 7.44079 6.28913 7.51413 6.05329C7.58746 5.81829 7.89496 5.74913 8.50996 5.60996L8.66829 5.57329C8.84329 5.53413 8.93079 5.51496 9.00163 5.46079C9.07163 5.40746 9.11663 5.32746 9.20663 5.16579L9.28829 5.01913Z",
    stroke: "#FFC700",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3333H4.99996M14.1666 2.04664C14.7841 2.16414 15.1508 2.29414 15.4666 2.68414C15.8641 3.17248 15.8433 3.69998 15.8008 4.75498C15.6508 8.54914 14.8008 13.3333 10.0008 13.3333C5.2008 13.3333 4.34996 8.54998 4.1983 4.75498C4.15663 3.69998 4.1358 3.17164 4.53163 2.68414C4.9283 2.19581 5.40246 2.11581 6.35163 1.95581C7.55759 1.75816 8.77793 1.66144 9.99996 1.66664C10.5983 1.66664 11.155 1.68748 11.6666 1.72331",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.8a85f69db7e3e65f0315649f2be0ed82.svg";
export { ForwardRef as ReactComponent };